import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ModalServiceService } from 'src/app/_services/modal-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
  selector: 'app-documents-cta',
  standalone: false,
  templateUrl: './documents-cta.component.html',
  styleUrl: './documents-cta.component.scss'
})
export class DocumentsCtaComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  translate: any;
  type: string = '';
  data: any;

  // ─── Email view state ─────────────────────────────────────────────────
  contactData: any[] = [];
  contactMode: any;
  selectedContact: any = null;
  ccText: string = '';

  // ─── New Recipient inline view ────────────────────────────────────────
  showNewRecipient: boolean = false;
  submitted: boolean = false;
  recipientSubmitted: boolean = false;
  newRecipientName: string = '';
  newRecipientEmail: string = '';

  // ─── Regenerate view state ────────────────────────────────────────────
  selectedTemplate: any = null;
  notes: string = '';
  generateSubmitted: boolean = false;
  pdfTemplates: any = {
    notes: null,
    templateId: null
  };
  templatesData: any[]=[];
  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private modalService: ModalServiceService,
    private globalJOServc: GlobalJobordersService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getLanguageData(): void {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe(data => {
        if (Object.keys(data).length !== 0) {
          this.translate = data;
          if (this.type === 'email') {
            this.getJobOrderContacts();
          }else{
            this.loadAllPDFTemplates(this.data.jobOrder?.jobOrderType?.id);

          }
        }
      })
    );
  }
  loadAllPDFTemplates(jobOrderTypeId: number): void {
      this.spinner.show();
      this.templatesData = [];
  
      this.push(
        this.globalJOServc.getPDFTemplatesList(jobOrderTypeId, 1, 200).subscribe(
          (resp: any) => {
            const body = resp?.body ?? resp;
          
          
            this.templatesData = body.data ?? [];
            this.spinner.hide();
          }, (err: any) => {
          this.errorUtil.setErrorMessage(err.status, err.error?.title ?? null, err.error?.title ?? null, 'error', 3000);
          this.spinner.hide();
        }
        )
      );
    }


  getJobOrderContacts(): void {
    this.contactData = [];
    var contactData: any[] = [];
    const customerId = this.data?.jobOrder?.generalDetails?.customer?.id || null;

    // Always add Job Order contact first if it has a name or email
    const joContact = this.data?.jobOrder?.locationAndAddress?.contact;
    if (joContact?.contactPersonName || joContact?.contactPersonEmail) {
      contactData.push({
        valueName: 'Job Order',
        modelFieldList: [joContact]
      });
    }
   
    if (customerId) {
      this.contactMode = 'select';
      this.globalJOServc.getJobOrderContactBaseOnCustomerSiteAssetProject(
        customerId, null, null
      ).subscribe(
        (res: any) => {
          if (res?.body) {
            res.body.forEach((loc: any) => {
              if (loc.contactPersonName) {
                const group = {
                  valueName: loc.customerId ? 'Customer' : loc.siteId ? 'Site' : 'Project',
                  modelFieldList: [loc]
                };
                contactData.push(group);
              }
            });

            // Append sentinel as last option, then assign
            this.contactData = [...contactData, { valueName: '', modelFieldList: [this.ADD_NEW_SENTINEL] }];

            // If no real contacts, fall back to new recipient form
            if (contactData.length === 0) {
              this.contactMode = 'createWithSearch';
              this.showNewRecipient = true;
            }
          }
        },
        (err: any) => {
          this.errorUtil.setErrorMessage(err.status, err.error?.title ?? null, err.error?.title ?? null, 'error', 3000);
        }
      );
    } else {
       // No customerId — show dropdown if JO contact exists, else open new recipient form
     
      this.contactData = [{ valueName: '', modelFieldList: [this.ADD_NEW_SENTINEL] }];
       
        // this.contactMode = 'select';
        // this.contactMode = 'create';
        // this.showNewRecipient = true;
      
    }
  }


  // Sentinel object used as the "Add New Recipient" option in the dropdown
  readonly ADD_NEW_SENTINEL = {
    contactPersonName: '+ Add New Recipient',
    contactPersonEmail: '',
    isAddNewSentinel: true
  };

  selectContact(event: any): void {
    console.log("Selected contact:", event?.value);
    if (!event || !event.value) return;

    if (event.value.isAddNewSentinel) {
      this.selectedContact = null;
      this.openNewRecipientForm();
      return;
    }

    this.showNewRecipient = false;
    this.selectedContact = event.value;
    this.globalJOServc.setJOContactData(event.value);
  }

  // ─── New Recipient toggle ─────────────────────────────────────────────
  openNewRecipientForm(): void {
    this.showNewRecipient = true;
    this.recipientSubmitted = false;
    this.newRecipientName = '';
    this.newRecipientEmail = '';
  }

  backToEmailForm(): void {
    this.showNewRecipient = false;
    this.recipientSubmitted = false;
    this.newRecipientName = '';
    this.newRecipientEmail = '';
  }

  saveNewRecipient(): void {
    this.recipientSubmitted = true;
    if (!this.newRecipientEmail.trim() || !this.isValidEmail(this.newRecipientEmail)) {
      return;
    }

    const newContact = {
      contactPersonName: this.newRecipientName.trim() || this.newRecipientEmail.trim(),
      contactPersonEmail: this.newRecipientEmail.trim()
    };

    const newEntry = {
      valueName: 'New Recipient',
      modelFieldList: [newContact]
    };

    this.contactData = [...this.contactData, newEntry];
    this.selectedContact = this.contactData[this.contactData.length - 1].modelFieldList[0];

    // Close form but keep newRecipientEmail — onSendEmail reads it
    this.showNewRecipient = false;
    this.recipientSubmitted = false;
    this.newRecipientName = '';
    // newRecipientEmail intentionally NOT cleared here
    this.onSendEmail();
  }

  // ─── Send email ───────────────────────────────────────────────────────
  onSendEmail(): void {
    this.submitted = true;
    console.log(this.ccTooMany, "Selected contact on send:", this.selectedContact,"====",this.ccInvalid);
    if (!this.selectedContact || this.ccInvalid || this.ccTooMany) {
      return;
    }

    // New Recipient flow → use typed email; dropdown flow → use selected contact email
    const toEmail = this.newRecipientEmail?.trim()
      ? this.newRecipientEmail.trim()
      : this.selectedContact?.contactPersonEmail?.trim() || null;

    if (!toEmail) {
      this.errorUtil.setErrorMessage(400, null, 'Recipient email is required', 'error', 3000);
      return;
    }

    // Build CC as string array, max 2
    const ccArray: string[] = this.ccArray.slice(0, 2);

    const body = {
      to: toEmail,
      cc: ccArray
    };

    this.spinner.show();
    this.globalJOServc.sendJobOrderPDF(this.data.jobOrder.id, this.data.pdf.id, body).subscribe(
      (resp: any) => {
        this.spinner.hide();
        if (resp.status === 200 || resp.status === 201) {
          this.errorUtil.setErrorMessage(200, 'Email sent successfully', null, 'success', 1000);
           this.globalJOServc.refreshJobOrderData$.emit('pdfGenerated');
            this.modalRef.hide();
        } else {
          this.errorUtil.setErrorMessage(resp.status, null, resp?.error?.title || 'Failed to send email', 'error', 3000);
        }
      },
      (err: any) => {
        this.spinner.hide();
        this.errorUtil.setErrorMessage(err.status, null, err?.error?.title || 'Failed to send email', 'error', 3000);
      }
    );
  }

  onCancelClick(): void {
    this.modalRef.hide();
  }

  // ─── Validation helpers ───────────────────────────────────────────────
  isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
  }

  get ccArray(): string[] {
    if (!this.ccText?.trim()) return [];
    return this.ccText.split(/[,;]+/).map((e: string) => e.trim()).filter((e: string) => e.length > 0);
  }

  get ccTooMany(): boolean {
    return this.ccArray.length > 2;
  }

  get ccInvalid(): boolean {
    return this.ccArray.some((e: string) => !this.isValidEmail(e));
  }

  // ─── Generate PDF ────────────────────────────────────────────────────
  onGenerate(): void {
    this.generateSubmitted = true;

    if (!this.pdfTemplates.templateId) {
      return;
    }

    const jobOrderId = this.data?.jobOrder?.id;
    if (!jobOrderId) {
      this.errorUtil.setErrorMessage(400, null, 'Job Order ID is missing', 'error', 3000);
      return;
    }

    const body = {
      templateId: this.pdfTemplates.templateId,
      notes: this.pdfTemplates.notes?.trim() || null
    };

    this.spinner.show();
    this.push(
      this.globalJOServc.generateJobOrderPDF(jobOrderId, body).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (resp.status === 200 || resp.status === 201) {
            this.errorUtil.setErrorMessage(200, 'PDF generated successfully', null, 'success', 1000);
            this.globalJOServc.refreshJobOrderData$.emit('pdfGenerated');
            this.modalRef.hide();
          } else {
            this.errorUtil.setErrorMessage(resp.status, null, resp?.error?.title || 'Failed to generate PDF', 'error', 3000);
          }
        },
        (err: any) => {
          this.spinner.hide();
          this.errorUtil.setErrorMessage(err.status, null, err?.error?.title || 'Failed to generate PDF', 'error', 3000);
        }
      )
    );
  }

  push(obs: any) {
    super.push(obs);
  }
}